import React from "react"

const FormSubmissionAttachmentDropzoneContext = React.createContext(null)

export default FormSubmissionAttachmentDropzoneContext
